export default "__VITE_ASSET__ChtHRVcn__"